module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "d3ce853440f00-d1e520"
    }
  }, [_c('h2', {
    staticClass: "chapter-number"
  }, [_vm._v("TWO")]), _vm._v(" "), _c('p', {
    staticClass: "flush-left-opener",
    staticStyle: {
      "text-indent": "0"
    }
  }, [_c('span', {
    staticClass: "drop-cap char-drop-cap"
  }, [_c('span', {
    staticClass: "char-drop-cap--drop-cap-"
  }, [_vm._v("S")])]), _c('span', {
    staticClass: "char-drop-cap--drop-cap-"
  }, [_vm._v("hortly after, my fist was saying "), _c('em', {
    staticClass: "char-italic italic"
  }, [_vm._v("blam")]), _vm._v(" on somebody’s door. ")]), _vm._v("It took a while, but somebody answered.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘What?’ she wanted to know.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘You’re the concierge of this establishment?’ I held up a badge.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("Now, if she looked at it too good, I’d maybe have to wade through half an hour’s worth of explaining what a task force was and sometimes even what a battered child was, though I always found that the phrase was fairly self-explanatory. If she was sleepy, she might mistake my badge for a cop badge, and everything would be Jake.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("She squinted past the door chain. ‘Oh. You’re here about the junkie.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘After a fashion,’ I confessed.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("She unbolted her door. She was dressed in a fright wig and chenille bathrobe. Her feet were adorned with the dirtiest slippers I’d ever seen. She reached up to a nail by the door for a ring of keys.")]), _c('span', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "indented"
  }, [_vm._v("‘Come on.’ She muscled past me, down the hall, and up a flight of splintery stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("Even though it was pressing three o’clock in the morning, there was a stereo on somewhere, playing "), _c('em', {
    staticClass: "char-italic italic"
  }, [_vm._v("Los Tigres Del Norte")]), _vm._v(" very softly. My Spanish was rusty, but the song was about a woman who shot a drug smuggler and stole his money. Somewhere else gave off the smell of cooking onions, and it made my stomach growl. A woman was crying in D-7 as we passed her door. The shower was running in D-9. The super stopped at D-11 and shoved the key in the door without knocking.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘This is her place,’ she said loudly. ‘But she ain’t in, I can tell you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘How do you know?’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘Because she’s in the hospital.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("She flung the door open. Immediately a stench assaulted my considerable nostrils that made me think maybe I was in a slaughterhouse.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘What the hell is that?’ I asked haltingly.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘What?’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘That smell?’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘What smell?’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘OK,’ I said, trying to ignore it.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘After you,’ she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("I took a tentative step into the lair, and was presented with something worse than the smell: the scene that was causing the smell. The dump was a one-room affair; sometimes they call it a studio. There was a sofa, a side table, a lamp, a large photograph of a penguin hanging on the wall, and seventeen years’ worth of accumulated garbage. In addition to the empty pizza boxes and moldy cottage cheese containers, there was a significant amount of blood and guts on the sofa. My guess was that our girl had her baby right there.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("I took one step farther in, and I could see the stove and fridge side-by-side to my left, and a bathroom without a door on it. The sink was filled with dishes and the tub had water in it.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("There was a window, but it had plastic over it, to keep out the cold I was guessing.")]), _c('span', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "indented"
  }, [_vm._v("‘You hear the ruckus a few nights ago?’ I asked, trying not to look anyplace in particular. ‘The baby being born?’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘Me? No. It was Gerard.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘I see. And where is Gerard?’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘D-10,’ she told me. ‘Right across the hall. But he ain’t in either. He’s still working. He’s a stripper. A male stripper. You ever hear of such a thing?’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘Yes,’ I said. ‘Now, about Lynette.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘She’s a junkie.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘You already told me that.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘She’s always late with the rent.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘And yet, you let her stay.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘It ain’t my place,’ she said, rolling her eyes. ‘I get to live here for free, and all I gots to do is take in the rent, notify people about this and that, and call the cops on a regular basis.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘You call the cops last Thursday night when Lynette …?’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘Gerard came to me,’ she sighed. ‘I went to the cops, yeah. But I knew there was something more to it. You don’t bleed that much just from having a baby.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘You’ve had a baby?’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘No,’ she said, adjusting her chenille robe, ‘but I seen it on the television.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘I’m going to look around in here now, for a minute,’ I said, swallowing.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘Help yourself,’ she told me. ‘I’m going back downstairs to have a little nightcap.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘Perfect.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("She left. I closed my eyes. I tried not to think about the scene in that room when the baby was born. I was just hoping to find something to tell me where the girl, the junkie, Lynette Baker might be hiding.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("I opened my eyes, and all of a sudden I could have kicked myself for not asking what the baby was named. It would be nice, I thought to myself, to be able to say the baby’s name to the junkie mother. Sometimes when you personalized things, a junkie would soften up. A little.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("I took a moment to stare at the picture of the penguin on the wall. It seemed hilariously out of place, though I did not, at that moment, feel much like laughing. I decided that it was the only thing out of place in the dump, so I should start by examining it more closely. Sometimes you got lucky.")]), _c('span', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "indented"
  }, [_vm._v("I took the few steps farther into the apartment that were necessary for me to grab the picture frame. I lifted the picture off the wall. There was a nail and a sizeable hole in the wall around the nail, like somebody had hit the nail so hard that the nail went all the way in and the hammer left an indentation, a little crater. Otherwise, there was nothing hidden on the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("I looked at the back of the picture. There was a very old slab of corrugated cardboard that was held in place by four finishing nails, one in each corner. I bent two of the nails a bit and slid the cardboard out of the way. A postage-stamp-sized baggie dropped to the floor. It was sealed with scotch tape and almost completely flat, but it had a nice white powdery substance in it. I scooped it up and pocketed it. Then I saw that, written in very light pencil in the corner of the backside of the cardboard, it said "), _c('em', {
    staticClass: "char-italic italic"
  }, [_vm._v("Jody")]), _vm._v(" and gave a telephone number.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("Like I said, sometimes you got lucky.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("I looked around, found the phone, and dialed the number. Just like that.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("It rang maybe fourteen times before a very disgruntled female voice said, ‘What?’ into my ear.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘Lynette,’ I said calmly.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("There was a pause, after which the person said, ‘What about her?’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘I’d like to speak with her.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘Me too,’ the voice said. ‘She owes me money.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘So, you have to be Jody,’ I said politely.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘I don’t "), _c('em', {
    staticClass: "char-italic italic"
  }, [_vm._v("have")]), _vm._v(" to be,’ she insisted.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘OK,’ I allowed, ‘maybe you "), _c('em', {
    staticClass: "char-italic italic"
  }, [_vm._v("want")]), _vm._v(" to be Jody, because I hear that I might purchase some interesting "), _c('em', {
    staticClass: "char-italic italic"
  }, [_vm._v("memorabilia")]), _vm._v(" from you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘What?’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("I got the impression that Jody was just about to hang up.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘I call it memorabilia,’ I hastened to say. ‘I know some people just call it trash – in fact, that’s just how Lynette described it to me. “It’s all "), _c('em', {
    staticClass: "char-italic italic"
  }, [_vm._v("junk")]), _vm._v(",” she said to me. But never the less, I am interested. And I am a somewhat significant collector.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("I could hear her smile. ‘I get it. That’s good. But, OK, look: I don’t sell to dealers. I’m strictly a neighborhood operation, you understand.’")]), _c('span', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "indented"
  }, [_vm._v("‘I hoped I might have a look-see, like, now.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘I’m sleeping. It’s three in the morning.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘If I like what you have,’ I told her softly, ‘I could buy out your entire inventory. But I’ll be gone by dawn, back to … back out of town, you understand.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘Christ,’ she mumbled, mostly to herself.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("I heard her light a cigarette.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘I would like to come over right now,’ I pressed.")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘Yeah.’ She coughed. ‘OK. But I’ll have to ask you for a minimum purchase no matter what. You know, for the inconvenience.’")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("‘For the inconvenience,’ I agreed.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-992154e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781780107394_epub_chap002.vue
// module id = 78
// module chunks = 0